import { render, staticRenderFns } from "./often.vue?vue&type=template&id=1c6753ca&scoped=true"
import script from "./often.vue?vue&type=script&lang=js"
export * from "./often.vue?vue&type=script&lang=js"
import style0 from "./often.vue?vue&type=style&index=0&id=1c6753ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6753ca",
  null
  
)

export default component.exports